<template>
    <div v-if="blParasiteParam && blParasiteParam.length>0">

        <!-- {{blParasiteDetailSelectedModel}} -->
        <div class="columns">
						<div class="column">
							<div class="">
                                <b-field label=""  >
                                    <b-select placeholder=""  
                                            @input="inputBlParasiteMaterSelected"
                                            expanded 
                                            v-model="blParasiteMaterSelectedModel ">
                                            <option  v-for=" blParasiteMaterDataSelect in blParasiteMaterSelect" 
                                            :value="blParasiteMaterDataSelect"
                                            :key="blParasiteMaterDataSelect">{{blParasiteMaterDataSelect}}</option>
                                    </b-select> 
                                    <p class="control">
                                        <b-button type="is-danger is-light"
                                                v-if="blParasiteMaterSelectedModel"
                                                @click="clearBlSelectAll "
                                                icon-right="delete" />  
                                    </p>
                                </b-field>




                            </div>
						</div>
                        <div class="column is-two-thirds">
							<div class="box" v-if="blParasiteMaterSelectedModel == 'Found' ">
                                <b-table 
                            
                                    :data="isEmpty ? [] : blParasiteParam"
                                    bordered 
                                    striped 
                                    hoverable 
                                    mobile-cards 
                                    checkable
                                    :checked-rows.sync="blParasiteDetailSelectedModel"
                                    >
                                        <b-table-column  label="Parameter"   v-slot="props">
                                            {{ props.row.name }}
                                        </b-table-column>


                                        <b-table-column  label="Amount"   v-slot="props">
                                               <b-input 
                                                type="number"
                                                :disabled="checkRowSelected( props.row.id)"
                                                v-model="props.row.amount"
                                                 ></b-input>
                                        </b-table-column>

                                        <b-table-column  label="Unit"   v-slot="props">
                                             <b-input
                                                v-model="props.row.unit"  
                                                :disabled="checkRowSelected( props.row.id)"
                                              >
                                             </b-input> 
                                        </b-table-column>

                                        <b-table-column  label="Remark"   v-slot="props">
                                                <b-input 
                                                v-model="props.row.remark"  
                                                :disabled="checkRowSelected( props.row.id)"
                                                ></b-input> 
                                        </b-table-column>



                                    <template slot="empty">
                                                        <section class="section">
                                                            <div class="content has-text-grey has-text-centered">
                                                                <p>
                                                                    <b-icon
                                                                        icon="emoticon-sad"
                                                                        size="is-large">
                                                                    </b-icon>
                                                                </p>
                                                                <p>Nothing here.</p>
                                                            </div>
                                                        </section>
                                    </template>        

                                </b-table>    
                                
                            </div>
						</div>
		</div>




            <!-- <b-table 
                            
                            :data="isEmpty ? [] : blParasiteParam"
                            bordered 
                            striped 
                            hoverable 
                            mobile-cards >
                        
                    <b-table-column  label="Parameter"   v-slot="props">
                        {{ props.row.name }}
                    </b-table-column>

                    <b-table-column  label="Values"   v-slot="props">
              

                            <b-radio v-model="props.row.selectedValue"
                               v-for="dat in props.row.result_dat_aval.id" 
                                :key="dat"
                                :native-value="dat"
                                type="is-success is-light is-outlined">
                                <span>{{dat}}</span>
                            </b-radio>


                            
                    </b-table-column>

                    <b-table-column  label="Selected"   v-slot="props">
                         {{ props.row.selectedValue }}
                          <b-button type="is-danger is-light"
                              v-if="props.row.selectedValue"
                              size="is-small"
                              @click="deleteSelected(props.row)"
                              icon-right="delete" />
                    </b-table-column>

                    <b-table-column  label="Amount"   v-slot="props">
                         {{ props.row.amount }}
                    </b-table-column>

                    <b-table-column  label="Unit"   v-slot="props">
                         {{ props.row.unit }}
                    </b-table-column>

                    <b-table-column  label="Remark"   v-slot="props">
                         {{ props.row.remark }}
                    </b-table-column>



                <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                </template>        

            </b-table> -->
    </div>
</template>


<script>
import {  mapState , mapMutations } from "vuex";



export default {
    name : "BlParasiteParam",
    computed:{
            ...mapState({
                blParasiteParam: state => state.manually_create_lab_automate.blParasiteParam ,
                blParasiteMaterSelect: state => state.manually_create_lab_automate.blParasiteMaterSelect ,
                blParasiteMaterSelected: state => state.manually_create_lab_automate.blParasiteMaterSelected ,
                blParasiteDetailSelected : state => state.manually_create_lab_automate.blParasiteDetailSelected ,
            }),

             blParasiteMaterSelectedModel : {
                get: function () {
                   return this.blParasiteMaterSelected
                },
                set: function (newValue) {
                   this.setBlParasiteMaterSelected(newValue)
                }
            },

            blParasiteDetailSelectedModel : {
                get: function () {
                   return this.blParasiteDetailSelected
                },
                set: function (newValue) {
                   this.setBlParasiteDetailSelected(newValue)
                }
            },


    },
    methods:{
        ...mapMutations({
            setBlParasiteMaterSelected : 'manually_create_lab_automate/setBlParasiteMaterSelected' ,
            setBlParasiteDetailSelected: 'manually_create_lab_automate/setBlParasiteDetailSelected' ,
        }),
        cleanBlParasiteParam(){
             this.blParasiteParam.forEach(element => {
                element.amount = ''
                element.unit = ''
                element.remark = ''
             });
        },
        deleteSelected(payload){
            //   console.log(payload)
            const tmp = this.blParasiteParam.find(dat=>dat.id == payload.id)
            if(tmp){
            // console.log("found--->",tmp)    
            tmp.selectedValue = ""
            }
        },
        checkRowSelected(_id){
          //  this.checkedRows.find(dat=>dat.id == _id) 
           return   !this.blParasiteDetailSelectedModel.find(dat=>dat.id == _id)  //true // disable true/disable false
        },
        // clearRowSelected(){
        //      this.setBlParasiteDetailSelected([])
        // },
        clearBlSelectAll(){
            this.blParasiteMaterSelectedModel = '' 
            this.setBlParasiteDetailSelected([])
        },
        inputBlParasiteMaterSelected(){
            // console.log("inputBlParasiteMaterSelected")
            // this.clearRowSelected()
            this.setBlParasiteDetailSelected([])
            this.cleanBlParasiteParam()
        }
    },
    data(){
        return {
            isEmpty : false,
          //  checkedRows : []
        }
    }

}
</script>